import {
  AppAction,
  ResponseMessage,
  ErrorMessage,
  ErrorMessageValue,
  RequestMessage,
} from '../types/actions';

class ContinueRequest extends RequestMessage {
  value: undefined;

  constructor() {
    super(AppAction.VIEW_CONTINUE);
  }
}

class ContinueResponse extends ResponseMessage {
  value: undefined;

  constructor(uuid: string) {
    super(AppAction.VIEW_CONTINUE, uuid);
  }
}

class ContinueError extends ErrorMessage {
  constructor(uuid: string, value: ErrorMessageValue) {
    super(AppAction.VIEW_CONTINUE, uuid, value);
  }
}

export { ContinueRequest, ContinueResponse, ContinueError };
